module.exports = __webpack_public_path__ + "img/iso-cert.2c698184.jpg";